module.exports = __webpack_public_path__ + "img/Kc.748d9af7.png";